/* eslint-disable react/display-name */
import React from 'react'

/**
 * Set a new parent to the child component
 *
 * @param {Component} Container - component to put as a parent component
 * @param {Function} propsMapper - get the props to apply to the container component
 */
export default (Container, propsMapper) => Component =>
  function withContainer(componentProps) {
    return (
      <Container {...(propsMapper ? propsMapper(componentProps) : {})}>
        <Component {...componentProps} />
      </Container>
    )
  }
